
import Vue from "vue";
import { mapMutations, mapState } from "vuex";
//Lodash
import _ from "lodash";
//components
import { EditIcon, CalendarIcon, ClipboardIcon, ArrowLeftIcon } from 'vue-feather-icons'
import RomaBreadcrumbs from "@/components/commons/RomaBreadcrumbs.vue";
import RomaUnit from "@/components/units/RomaUnit.vue";
import RomaCoverage from "@/components/planner/coverage/RomaCoverage.vue";
import RomaPurpose from "@/components/planner/purpose/RomaPurpose.vue";
import RomaOa from "@/components/planner/objetive/RomaOa.vue";
import RomaActivityList from "@/components/planner/activity/RomaActivityList.vue";
import RomaPercentage from "@/components/commons/RomaPercentage.vue";
//store
import UnitPlan from "@/store/units/UnitPlan";
import UnitPlanOa from "@/store/planner/objetive/UnitPlanOa";
import UnitPlanActivity from "@/store/planner/activity/UnitPlanActivity";
import UnitPlanActivityDua from "@/store/planner/activity/UnitPlanActivityDua";
import UnitPlanActivityFile from "@/store/planner/activity/UnitPlanActivityFile";
import UnitPlanActivityIe from "@/store/planner/activity/UnitPlanActivityIe";

//interfaces
import { IUnitPlan } from "@/interfaces/units/IUnitPlan";


export default Vue.extend({
  name: 'OrganizerUnit',
  // @ts-ignore
  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.savedCoverage) {
      next();
    } else {
      const answer = window.confirm(this.$vuetify.lang.t('$vuetify.component.romaCoverage.unsavedChanges'));
      if (answer) {
        this.executeSaveCoverage = true;
      } else {
        next();
      }
    }
  },
  created() {
    // Movilización entre tabs al inicio de la pagina
    const unit: UnitPlan = UnitPlan.find(this.$route.params.id)
    if (this.$store.state.user.privileges.canSeeUnitCoverageAndActivities && unit && (unit.editing_status_id != 0 || unit.status_plan === 'En Replanificación: En Edición')) {
      this.acitvedTab = 'tab-2';
    } else {
      this.acitvedTab = this.$route.hash.substr(1) ? this.$route.hash.substr(1) : 'tab-0';
    }

  },
  data() {
    return {
      savedCoverage: true,
      userPrivileges: this.$store.state.user.privileges,
      userId: this.$store.state.user.userId,
      acitvedTab: null,
      loadingActivities: true,
      executeSaveCoverage: false,
      selectedWeekFromCoverage: null,
      tabs: [
        {
          label: 'purposeTabLabel',
          icon: 'far fa-edit',
          iconComponent: EditIcon,
          component: RomaPurpose,
          enable: this.$store.state.user.privileges.canSeePurposeAndUnitObjectives,
        },
        {
          label: 'coverageTabLabel',
          icon: 'fas fa-bullseye',
          component: RomaOa,
          enable: this.$store.state.user.privileges.canSeePurposeAndUnitObjectives && this.$store.state.user.institution.type.implementador,
        },
        {
          label: 'coverageTabLabel',
          icon: 'fas fa-calendar-alt',
          iconComponent: CalendarIcon,
          component: RomaCoverage,
          enable: this.$store.state.user.privileges.canSeeUnitCoverageAndActivities,
        },
        {
          label: 'activitiesTabLabel',
          icon: 'fas fa-user-check',
          iconComponent: ClipboardIcon,
          component: RomaActivityList,
          enable: this.$store.state.user.privileges.canSeeUnitCoverageAndActivities,
        },
      ],
      unit: null,
    };
  },
  computed: {
    ...mapState(["user"]),
    dataReady() {
      const unit: UnitPlan = UnitPlan.find(this.$route.params.id)
      if (
        (unit === null || unit === undefined || unit.id <= 0) &&
        this.$route.name === "organizer-unit"
      ) {
        window.location.href = "/organizer";
        alert("El plan unidad debe estar en la lista de planes unidad");
        return null;
      }

      if (!(unit instanceof UnitPlan)) {
        this.setUnit(new UnitPlan(unit))
      } else {
        this.setUnit(unit);
      }
      return this.unit;
    },
    getUnitPlan(): IUnitPlan {
      if (this.unit === null || this.unit === undefined) {
        return {
          itemsPlannedPercentage: 0,
          itemsDonePercentage: 0,
          status_plan: '',
          hours: 0,
          oa_count: 0,
          activity_count: 0
        }
      }

      const unitPlan = UnitPlan.query()
        .where('id', this.unit.id)
        .withAll()
        .first();
      /*
      let itemsDonePercentage = unitPlan.itemsDonePercentage?  unitPlan.itemsDonePercentage: 0;
      let itemsPlannedPercentage = unitPlan.itemsPlannedPercentage? unitPlan.itemsPlannedPercentage: 0;
      unitPlan.percentage = Math.floor((itemsDonePercentage + itemsPlannedPercentage) / 2);
      */
      return unitPlan;
    },
  },
  watch: {
    async unit(newValue) {
      //await this.updateActivities();
      this.updateOAs();
    },
    acitvedTab(newValue, oldValue) {
      if (oldValue === "tab-2" && !this.savedCoverage) {
        /*
        this.$store.state.snackbar = {
          show: true,
          color: "warning",
          text: this.$vuetify.lang.t(
            "$vuetify.component.romaCoverage.unsavedChangesWarning"
          ),
        };
        */

        if (!this.savedCoverage) {
          //confirm save
          const answer = window.confirm('Hay cambios realizados, ¿DESEA GUARDAR?');
          if (answer && !this.executeSaveCoverage) {
            this.executeSaveCoverage = true;
          }
        }
      }
      if (newValue === "tab-3" && !this.loadingActivities) {
        this.refreshActivities();
      }
    },
  },
  methods: {
    ...mapMutations(['appLoading']),
    goToActivity(week: any) {
      this.selectedWeekFromCoverage = week;
      this.acitvedTab = 'tab-3';
    },
    async refreshActivities() {
      await this.updateActivities();
    },
    checkCoverage(value: boolean) {
      this.savedCoverage = value;
      if (value) {
        this.executeSaveCoverage = false;
      }
    },
    updateOAs() {
      const request = new URLSearchParams(`idPlanUnidad=${this.unit.id}`);
      this.$store.dispatch("romaOAsBySubjectId", request).then((response) => {
        UnitPlanOa.insertOrUpdate({ data: response.data.content });
      });
    },
    async updateActivities() {
      this.loadingActivities = true;
      this.appLoading();
      await UnitPlanActivity.deleteAll();
      await UnitPlanActivityDua.deleteAll();
      await UnitPlanActivityFile.deleteAll();
      await UnitPlanActivityIe.deleteAll();
      this.$store
        .dispatch("getUnitPlanActivities", this.unit.id)
        .then((response) => {
          response.data.content.forEach((activity) => {
            let duaIds: any[] = [];
            activity.selectedDuas.forEach((categoryDua: any) => {
              categoryDua.duas.forEach((dua: any) => {
                duaIds.push(dua.id);
              });
            });
            const data = {
              id: activity.id,
              unitplan_id: this.unit.id,
              title: activity.titulo,
              type_id: activity.tipoEvaluacion.id,
              instrument_id: activity.tipoInstrumentoEvaluacion
                ? activity.tipoInstrumentoEvaluacion.id
                : "",
              type: activity.tipoEvaluacion.nombre,
              instrument: activity.tipoInstrumentoEvaluacion
                ? activity.tipoInstrumentoEvaluacion.nombre
                : "",
              activityLer: activity.actividadEnsenanza,
              activityEva: activity.actividadEvaluacion,
              duas: duaIds,
              momentos: _.sortBy(activity.momentos, 'id', 'asc').map((momento) => {
                momento.evaluaciones = _.sortBy(momento.evaluaciones, 'id', 'asc');
                return momento;
              }),
              pies: activity.pies,
              ies: activity.selectedIes,
              files: activity.fileList,
              comments: activity.comments,
              order: activity.order,
              fechaClase: activity.fechaClase,
              semanaClase: activity.semanaClase,
              mesClase: activity.mesClase,
            };
            UnitPlanActivity.insertOrUpdate({ data: data }).then(() => {
              // Inserta sus ies seleccionados en el vuex orm
              UnitPlanActivityIe.insertOrUpdate({
                data: data.ies.map((i) => {
                  return {
                    ie_id: i.id,
                    activity_id: data.id,
                  };
                }),
              });
              // Inserta sus duas seleccionados en el vuex orm
              UnitPlanActivityDua.insertOrUpdate({
                data: data.duas.map((i) => {
                  return {
                    dua_id: i,
                    activity_id: data.id,
                  };
                }),
              });
            });
          });

          this.unit.activity_count = response.data.content.length
          UnitPlan.update({ data: this.unit });

          this.loadingActivities = false;

          //Se verifica si se está guardando la cobertura para no cerrar el loading
          if (!this.executeSaveCoverage) {
            this.appLoading(false);
          }

        });
    },
    setUnit(unit) {
      this.unit = unit;
    },
    async changeHash(index: any) {
      // await this.$nextTick();
      // if (!this.savedCoverage) {
      //   this.acitvedTab = 'tab-2';
      //   return;
      // }
      // Cambio hash en cada cambio de tab
      this.$store.commit("highlightWords", ""); // Quito el resaltado de palabra
      window.location.hash = index;
    },
  },
  components: {
    RomaBreadcrumbs,
    RomaUnit,
    RomaOa,
    RomaCoverage,
    RomaPercentage,
    EditIcon,
    CalendarIcon,
    ClipboardIcon,
    ArrowLeftIcon
  },
});
